



































import Vue from 'vue';
import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format';
import ToolbarMunicipality from "@/components/ToolbarMunicipality.vue";
import {UserViewModel} from "@/models/UserViewModel";
import ToolbarMetroVan from "@/components/ToolbarMetroVan.vue";
import Vuelidate from 'vuelidate';
// import {getCookie, removeCookie} from "typescript-cookie";
import "@fontsource/nunito-sans";

Vue.use(VueFilterDateFormat);

export default Vue.extend({
  name: 'App',
  components: {ToolbarMetroVan, ToolbarMunicipality},
  computed: {
    loggedInUser(): UserViewModel{
      return this.$store.state.loggedInUser;
    }
  },
  data: () => ({
    //
  }),
  mounted() {
    // do something
  },
  methods: {
   // do something here
  },
  beforeCreate() {
    //this.$store.dispatch('retrieveUserInfo');

    // if ( this.$store.state.loggedInUser == null ) {
    //
    // }
    // this.$store.commit( '' , )
  },

});
